<div
  class="flex flex-col justify-between w-full min-h-dvh wrapper"
  [ngClass]="[isCollapsed() ? 'collapsed' : 'uncollapsed', user()?.userTypeClass || '']"
>
  <div class="logo-with-menu">
    <button class="close-button" nzType="text" (click)="collapse()">
      <i>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
          <path
            d="M2.93129 3.53578L2.9797 3.4797C3.15721 3.30219 3.43499 3.28605 3.63073 3.43129L3.68681 3.4797L7.99992 7.79259L12.3131 3.4797C12.5083 3.28444 12.8249 3.28444 13.0201 3.4797C13.2154 3.67496 13.2154 3.99155 13.0201 4.18681L8.70725 8.49992L13.0201 12.8131C13.1977 12.9905 13.2138 13.2683 13.0685 13.4641L13.0201 13.5201C12.8427 13.6977 12.5649 13.7138 12.3691 13.5685L12.3131 13.5201L7.99992 9.20725L3.68681 13.5201C3.49155 13.7154 3.17496 13.7154 2.9797 13.5201C2.78444 13.3249 2.78444 13.0083 2.9797 12.8131L7.29259 8.49992L2.9797 4.18681C2.80219 4.00929 2.78605 3.73152 2.93129 3.53578Z"
            fill="#222528"
          />
        </svg>
      </i>
    </button>
    <div class="flex justify-center items-center py-[3rem]" (click)="collapse()">
      <korviu-logo size="m" theme="white"></korviu-logo>
    </div>
    <nav class="menu flex flex-col gap-4">
      <div
        cdkDropList
        cdkDropListLockAxis="y"
        class="general-menu flex flex-col gap-4"
        [cdkDropListData]="generalSections()"
        (cdkDropListDropped)="reorderGeneralSections($event)"
      >
        @for (section of generalSections(); track section.id) {
          <div
            cdkDrag
            cdkDragLockAxis="y"
            cdkDragPreviewContainer="parent"
            class="sidebar-menu-item sidebar-menu-item--draggable"
            [cdkDragData]="section"
            [cdkDragStartDelay]="dragStartDelay"
            (cdkDragStarted)="onDragStarted()"
            (cdkDragEnded)="onDragEnded()"
          >
            <ng-container
              [ngTemplateOutlet]="sectionTemplate"
              [ngTemplateOutletContext]="{ section: section, draggable: true }"
            ></ng-container>
          </div>
        }
      </div>
      <nz-divider></nz-divider>
      <div class="special-menu flex flex-col gap-4">
        @for (section of specialSections(); track section.id) {
          <div class="sidebar-menu-item">
            <ng-container
              [ngTemplateOutlet]="sectionTemplate"
              [ngTemplateOutletContext]="{ section: section, draggable: false }"
            ></ng-container>
          </div>
        }
      </div>
    </nav>
  </div>
  <div class="user-profile">
    <user-profile></user-profile>
  </div>
</div>

<ng-template #sectionTemplate let-section="section" let-draggable="draggable">
  <a
    class="sidebar-menu-title w-full px-4 py-2 flex items-center gap-4"
    [routerLink]="draggable && isNavigationBlocked() ? null : [section.url]"
    routerLinkActive="active"
    (click)="preventNavigationDuringDrag($event)"
  >
    @let state = isActiveRoute(section.url) ? 'active' : 'default';

    <img class="size-[2rem]" [src]="section[state]" />
    <span class="paragraph-medium font-normal">{{ section.label | translate }}</span>
    @if (draggable) {
      <span class="drag-handle" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14" fill="none">
          <path
            d="M0.75086 12.5514H19.2508C19.6651 12.5514 20.0008 12.8757 20.0008 13.2757C20.0008 13.6424 19.7187 13.9454 19.3526 13.9933L19.2508 14H0.75086C0.33664 14 0.000860214 13.6757 0.000860214 13.2757C0.000860214 12.909 0.28301 12.606 0.64909 12.558L0.75086 12.5514ZM0.75086 6.27704H19.2508C19.6651 6.27704 20.0008 6.60133 20.0008 7.00134C20.0008 7.36803 19.7187 7.67107 19.3526 7.71907L19.2508 7.72564H0.75086C0.33664 7.72564 0.000860214 7.40134 0.000860214 7.00134C0.000860214 6.63465 0.28301 6.3316 0.64909 6.2836L0.75086 6.27704ZM0.75 0H19.25C19.6642 0 20 0.324283 20 0.724299C20 1.09099 19.7178 1.39402 19.3518 1.44198L19.25 1.4486H0.75C0.33578 1.4486 0 1.12432 0 0.724299C0 0.357611 0.28215 0.0545733 0.64823 0.00661504L0.75 0Z"
            fill="#505760"
          />
        </svg>
      </span>
    }
  </a>
</ng-template>
